import { DateTimeInput, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { DateTimeDataFormat } from 'Lib/Format';
import React from 'react';

let AsLiquidLimitCuringSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Curing Time After Mixing">
        <Field
          input={<DateTimeInput />}
          name="StartedAtDateTime"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
        />
        <Field
          input={<DateTimeInput />}
          name="CompletedAtDateTime"
          dataFormat={DateTimeDataFormat.UnspecifiedLocalDateTime}
        />
        <Field input={<TextOutput />} name="CuringDuration" />
      </ListFieldSection>
    </>
  );
};

AsLiquidLimitCuringSection = withInjectedProps(AsLiquidLimitCuringSection);

export { AsLiquidLimitCuringSection };
export default AsLiquidLimitCuringSection;
